export const getKeyBySelector = (item, keySelector) => {
    const key = typeof keySelector === 'function' ? keySelector(item) : item[keySelector];
    if (typeof key !== 'string' && typeof key !== 'number')
        throw new Error(`Invalid key value: ${key}.`);
    return key;
};
//# sourceMappingURL=get-key-by-selector.js.map